<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { paymenttermService } from "../../../../services/paymentservice/paymentterm.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Term List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      termList: {},
      fetchingStats: false,
      title: "Term Templates List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '?page=0') {
      this.fetchingStats = false;
      paymenttermService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.termList = response;
        });
    },

    deleted: function(id) {
      paymenttermService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-property-payment-term-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-property-payment-term-add'}" :title="$t('setting.property.payment-term.text')" />
    <List v-bind:dataList="termList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ 
            `name: ${$t('setting.property.payment-term.name')}`, 
            `period: ${$t('setting.property.payment-term.period')}`, 
            `payment_period_type: ${$t('setting.property.payment-term.period_type')}`, 
            `rounding_rule: ${$t('setting.property.payment-term.rounding_rule')}`, 
          ]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-property-payment-term-edit'}"
          v-bind:filter="{
            search: ['payment_terms.name'],
            dropdown: []
          }"
          
    />      
  </Layout>
</template>